<script context="module" lang="ts">
    export interface TileProps {
        icon: string;
        title: string;
        text: string;
    }
    
</script>

<script lang="ts">

    export let props: TileProps;

</script>

<style lang="scss">
	.tile {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin: 60px 0 0 0;
        &__icon {
            height: 70px;
            padding: 0 0 30px 0;
        }
        &__title {
            padding: 0 0 30px 0;
            text-align: center;
        }
        &__text {
            padding: 0 16px 0 16px;
            text-align: center;
            padding: 0 0 30px 0;
        }
	}

    @include large {
        .tile {
            margin: 60px 15px 0 15px;
            padding: 30px 30px 30px 30px;
            transition: all 1s;
            border-radius: 20px 20px 20px 20px;
            justify-content: flex-start;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            &:hover {
                color: $color_primary;
                background-color: $color_grey;
                box-shadow: 8px 8px 8px $color_text;
            }
            &__title {
                text-align: center;
            }
        }
    }

</style>

<div class="tile">
    <img class="tile__icon" alt="icon" src={props.icon}>
    <div class="tile__title font__h3">{props.title}</div>
    <div class="tile__text">{props.text}</div>
</div>
